var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 94,
    viewBox: "0 0 161 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.0827 2H4.70677C3.21186 2 2 3.21186 2 4.70677V54.782C2 56.2769 3.21186 57.4887 4.70677 57.4887H75.0827C76.5776 57.4887 77.7895 56.2769 77.7895 54.782V4.70677C77.7895 3.21186 76.5776 2 75.0827 2Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8947 57.4888V80.4963M26.3608 80.4963H53.4285",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.188 18.2407H92.6769C90.8083 18.2407 89.2935 19.7555 89.2935 21.6242V88.6167C89.2935 90.4853 90.8083 92.0001 92.6769 92.0001H127.188C129.057 92.0001 130.572 90.4853 130.572 88.6167V21.6242C130.572 19.7555 129.057 18.2407 127.188 18.2407Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.609 37.188H140.722C139.227 37.188 138.015 38.3998 138.015 39.8948V89.2933C138.015 90.7882 139.227 92 140.722 92H155.609C157.104 92 158.316 90.7882 158.316 89.2933V39.8948C158.316 38.3998 157.104 37.188 155.609 37.188Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8946 14.1804C42.137 14.1804 43.9548 12.3626 43.9548 10.1202C43.9548 7.87785 42.137 6.06006 39.8946 6.06006C37.6523 6.06006 35.8345 7.87785 35.8345 10.1202C35.8345 12.3626 37.6523 14.1804 39.8946 14.1804Z",
    fill: "#FF6000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.271 30.4211C112.513 30.4211 114.331 28.6033 114.331 26.3609C114.331 24.1186 112.513 22.3008 110.271 22.3008C108.028 22.3008 106.21 24.1186 106.21 26.3609C106.21 28.6033 108.028 30.4211 110.271 30.4211Z",
    fill: "#FF6000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.165 48.6917C150.034 48.6917 151.549 47.1769 151.549 45.3083C151.549 43.4396 150.034 41.9248 148.165 41.9248C146.297 41.9248 144.782 43.4396 144.782 45.3083C144.782 47.1769 146.297 48.6917 148.165 48.6917Z",
    fill: "#FF6000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8946 54.1052C42.137 54.1052 43.9548 52.2874 43.9548 50.045C43.9548 47.8027 42.137 45.9849 39.8946 45.9849C37.6523 45.9849 35.8345 47.8027 35.8345 50.045C35.8345 52.2874 37.6523 54.1052 39.8946 54.1052Z",
    fill: "#FF6000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.271 87.9399C112.513 87.9399 114.331 86.1221 114.331 83.8797C114.331 81.6374 112.513 79.8196 110.271 79.8196C108.028 79.8196 106.21 81.6374 106.21 83.8797C106.21 86.1221 108.028 87.9399 110.271 87.9399Z",
    fill: "#FF6000"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M148.165 86.5865C150.034 86.5865 151.549 85.0717 151.549 83.203C151.549 81.3344 150.034 79.8196 148.165 79.8196C146.297 79.8196 144.782 81.3344 144.782 83.203C144.782 85.0717 146.297 86.5865 148.165 86.5865Z",
    fill: "#FF6000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature5);
export default __webpack_public_path__ + "static/media/feature5.28ad69ef9f73e13aa595681ec9c485e6.svg";
export { ForwardRef as ReactComponent };